// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es9:true*/
const {ms} = require('../../../../util/date.js');

const E = module.exports;

E.COMPANY_NAME = 'Bright Data Ltd.';
E.USER_TYPES = {
    REGULAR: 1,
    ROOT: 2,
};
E.PRODUCT_CODE = 'sdk_cp';
E.USER_ANALYTICS_EVENT = {
    SIGNUP_SUCCESS: `${E.PRODUCT_CODE}_signup_success`,
    EMAIL_VERIFIED: `${E.PRODUCT_CODE}_email_verified`,
    PARTNER_REGISTERED: `${E.PRODUCT_CODE}_partner_registered`,
};
E.PAYMENT_TYPES = {
    FIXED: 'fixed',
    PER_IP: 'per_ip',
    PER_DEVICE: 'per_device',
    PER_INSTALL: 'per_install',
    PER_OPTIN: 'per_optin',
    MIN: 'min',
};
E.BILLING_TYPES = {
    PER_IP: 'per_ip',
    PER_DEVICE: 'per_device',
    PER_INSTALL: 'per_install',
    PER_OPTIN: 'per_optin',
    EMPTY: 'empty',
};
E.BILLING_SOURCE = {
    PARTNER: 'partner',
    APP: 'app',
};
E.TOKEN_EVENTS = {
    CREATED: 'created',
    USED: 'used',
};
E.PAYOUT_EVENTS = {
    CREATED: 'created',
    REVERTED: 'reverted',
    APPROVED: 'approved',
    INVOICE_ATTACHED: 'invoice_attached',
    VERIFIED: 'verified',
    PAID: 'paid',
};
E.INVOICE_STATUS = {
    UNKNOWN: 'unknown',
    REQUESTED: 'requested',
    SENT: 'sent',
    PAID: 'paid',
};
E.BILL_EVENTS = {
    CREATED: 'created',
};
E.TRANSACTION_EVENTS = {
    CREATED: 'created',
    STATUS_CHANGED: 'status_changed',
    EDITED: 'edited',
    REMOVED: 'removed',
};
E.BILL_KINDS = {
    ONE_TIME: 'one_time',
    MONTHLY: 'monthly',
    REFERRAL: 'referral',
};
E.PARTNER_EVENTS = {
    CREATED: 'created',
    EDITED: 'edited',
    BILLING_ADDED: 'billing_added',
    BILLING_EDITED: 'billing_edited',
    BILLING_REMOVED: 'billing_removed',
};
E.APP_EVENTS = {
    CREATED: 'created',
    EDITED: 'edited',
    SUBMITTED: 'submitted',
    BILLING_ADDED: 'billing_added',
    BILLING_EDITED: 'billing_edited',
    BILLING_REMOVED: 'billing_removed',
    STATUS_CHANGED: 'status_changed',
};
E.USER_EVENTS = {
    CREATED: 'created',
    EDITED: 'edited',
};
E.REVIEW_STATUSES = {
    WAITING_REVIEW: 'waiting_review',
    PENDING_REVIEW: 'pending_review',
    PENDING_APPROVAL: 'pending_approval',
    REJECTED: 'rejected',
    APPROVED: 'approved',
    CANCELED: 'canceled',
};
E.REVIEW_STATUSES_META = {
    [E.REVIEW_STATUSES.WAITING_REVIEW]: {
        name: 'Waiting for Review',
        routes: {
            [E.REVIEW_STATUSES.PENDING_REVIEW]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.CANCELED]: E.USER_TYPES.REGULAR,
        },
    },
    [E.REVIEW_STATUSES.PENDING_REVIEW]: {
        name: 'Review in Progress',
        routes: {
            [E.REVIEW_STATUSES.PENDING_REVIEW]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.PENDING_APPROVAL]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.CANCELED]: E.USER_TYPES.REGULAR,
        },
    },
    [E.REVIEW_STATUSES.PENDING_APPROVAL]: {
        name: 'Waiting for Approval',
        routes: {
            [E.REVIEW_STATUSES.PENDING_REVIEW]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.REJECTED]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
            [E.REVIEW_STATUSES.CANCELED]: E.USER_TYPES.REGULAR,
        },
    },
    [E.REVIEW_STATUSES.REJECTED]: {
        name: 'Rejected',
        verdict: true,
        final: true,
        routes: {},
    },
    [E.REVIEW_STATUSES.APPROVED]: {
        name: 'Approved',
        verdict: true,
        final: true,
        routes: {},
    },
    [E.REVIEW_STATUSES.CANCELED]: {
        name: 'Canceled',
        final: true,
        routes: {},
    },
};
E.APP_STATUSES = {
    IMPLEMENTATION: 'implementation',
    PENDING_REVIEW: 'pending_review',
    APPROVED: 'active',
    DISABLED: 'disabled',
    LIVE: 'live',
    REMOVED: 'removed',
};
E.APP_STATUSES_META = {
    [E.APP_STATUSES.IMPLEMENTATION]: {
        name: 'Implementation',
        is_interactive: true,
        routes: {
            [E.APP_STATUSES.PENDING_REVIEW]: E.USER_TYPES.REGULAR,
            [E.APP_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.DISABLED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.LIVE]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.REMOVED]: E.USER_TYPES.ROOT,
        },
    },
    [E.APP_STATUSES.PENDING_REVIEW]: {
        name: 'Under Review',
        routes: {
            [E.APP_STATUSES.IMPLEMENTATION]: E.USER_TYPES.REGULAR,
            [E.APP_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
        },
    },
    [E.APP_STATUSES.APPROVED]: {
        name: 'Approved',
        is_interactive: true,
        routes: {
            [E.APP_STATUSES.APPROVED]: E.USER_TYPES.REGULAR,
            [E.APP_STATUSES.DISABLED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.IMPLEMENTATION]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.PENDING_REVIEW]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.LIVE]: E.USER_TYPES.REGULAR,
            [E.APP_STATUSES.REMOVED]: E.USER_TYPES.ROOT,
        },
    },
    [E.APP_STATUSES.LIVE]: {
        name: 'Live',
        is_interactive: true,
        routes: {
            [E.APP_STATUSES.LIVE]: E.USER_TYPES.REGULAR,
            [E.APP_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.DISABLED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.REMOVED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.IMPLEMENTATION]: E.USER_TYPES.ROOT,
        },
    },
    [E.APP_STATUSES.DISABLED]: {
        name: 'Disabled',
        is_interactive: true,
        routes: {
            [E.APP_STATUSES.APPROVED]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.LIVE]: E.USER_TYPES.ROOT,
            [E.APP_STATUSES.REMOVED]: E.USER_TYPES.ROOT,
        },
    },
    [E.APP_STATUSES.REMOVED]: {
        name: 'Removed',
        routes: {},
    },
};
E.INVALID_URL_ERROR = 'Invalid URL format';
E.INVALID_EMAIL_ERROR = 'Invalid email format';
E.MINIMAL_REDEEM_AMOUNT = 1;
E.ERROR_ALERT_DURATION = 5000;
E.SUCCESS_ALERT_DURATION = 3000;
E.LANDING_URL = 'https://bright-sdk.com';
E.APP_URL = `${E.LANDING_URL}/cp`;
E.FAQ_URL = 'https://help.bright-sdk.com/hc/en-us';
E.FAQ_PAYMENT_DETAILS = 'https://help.bright-sdk.com/hc/en-us/articles/20009767859857-What-is-the-process-to-get-the-monthly-payment-';
E.ONBOARDING_GUIDE_URL = 'https://bright-sdk.com/wp-content/uploads/2024/02/Bright-SDK-onboarding-guide.pdf';
E.INVOICES_URL = `${E.APP_URL}/billing/invoices`;
E.PLATFORMS = {
    ios: {id: 'ios', label: 'iOS'},
    win: {id: 'win', label: 'Windows'},
    android: {id: 'android', label: 'Android', hidden: true},
    webos: {id: 'webos', label: 'WebOS'},
    roku: {id: 'roku', label: 'Roku'},
    macos: {id: 'macos', label: 'MacOS'},
    tizen: {id: 'tizen', label: 'Tizen'},
};
E.PLATFORM_ALIASES = {
    amazon: {
        id: 'amazon',
        label: 'Amazon',
        for: 'android',
    },
    huawei: {
        id: 'huawei',
        label: 'Huawei',
        for: 'android',
    },
    android_apk: {
        id: 'android_apk',
        label: 'Android out of store',
        for: 'android',
    },
};
E.PLATFORMS_ID_PRESET = {
    ios: true,
    macos: true,
    webos: true,
    android: true,
    amazon: true,
    huawei: true,
    android_apk: true,
    roku: true,
    tizen: true,
};
E.FIELD_KIND = {
    URL: 'url',
    EMAIL: 'email',
    PASSWORD: 'password',
    TEXT: 'text',
    BOOLEAN: 'bool',
    FILE: 'file',
    HIDDEN: 'hidden',
};
E.MAX_VERSION_LEN = 64;
E.MAX_TESTFLIGHT_URL_LEN = 200;
E.MAX_ROKU_BETA_URL_LEN = 200;
E.MAX_ID_LEN = 256;
E.MAX_NAME_LEN = 64;
E.MAX_URL_LEN = 512;
E.MAX_NUM_LEN = 16;
E.MAX_EMAIL_LEN = 64;
E.MAX_PHONE_LEN = 32;
E.MAX_PROMO_LEN = 128;
E.MAX_REF_LEN = 20;
E.MAX_APP_COMMENT_LEN = 1000;
E.ATTACH_KINDS = {
    PACKAGE: 'package',
    INVOICE: 'invoice',
    CHECKLIST_ATTACH: 'checklist_attachment',
    CHECKLIST_MEDIA: 'checklist_media',
    REVIEW_ATTACH: 'review_attachment',
};
E.MAX_FILE_SIZE = {
    [E.ATTACH_KINDS.CHECKLIST_ATTACH]: 100*1024*1024, // 100MB
    [E.ATTACH_KINDS.CHECKLIST_MEDIA]: 500*1024*1024, // 500MB
    [E.ATTACH_KINDS.REVIEW_ATTACH]: 500*1024*1024, // 500MB
    [E.ATTACH_KINDS.PACKAGE]: 500*1024*1024, // 500MB
    [E.ATTACH_KINDS.INVOICE]: 5*1024*1024, // 5MB
};
E.VIDEO_EXTS = ['webm', 'mp4', 'ogg'];
E.ALLOWED_FILE_EXT = {
    [E.ATTACH_KINDS.PACKAGE]: {
        windows: ['zip', 'exe'],
        win: ['zip', 'exe'],
        android: ['zip', 'apk'],
        macos: ['zip', 'pkg', 'dmg'],
        webos: ['zip', 'ipk'],
        node: ['zip', 'ipk'],
        default: ['zip'],
    },
    [E.ATTACH_KINDS.CHECKLIST_ATTACH]: {
        default: ['png', 'jpg', 'jpeg', 'webp', ...E.VIDEO_EXTS],
    },
    [E.ATTACH_KINDS.CHECKLIST_MEDIA]: {
        default: ['png', 'jpg', 'jpeg', 'webp', ...E.VIDEO_EXTS],
    },
    [E.ATTACH_KINDS.REVIEW_ATTACH]: {
        default: ['png', 'jpg', 'jpeg', 'webp', ...E.VIDEO_EXTS],
    },
    [E.ATTACH_KINDS.INVOICE]: {
        default: ['pdf', 'zip'],
    },
};
E.MAX_REVIEW_DURATION = ms.DAY;
E.APP_VIEW_SECTION_IDS = {
    SUBMISSION: 'submission',
    SELF_CHECK: 'self-check',
    REVIEW: 'review',
    STATUS: 'status',
    ESSENTIAL: 'essential',
    BUNDLE: 'bundle',
    CHANNELS: 'channels',
    BILLING: 'billing',
    PARAMS: 'params',
    CHARTS: 'charts',
    DANGER: 'danger-section',
};
E.PARTNER_VIEW_SECTION_IDS = {
    LEGAL: 'legal',
    CONTACTS: 'contacts',
    BILLING: 'billing',
    PAYMENT_DETAILS: 'payment_details',
    USERS: 'users',
    APPS: 'apps',
    BUNDLES: 'bundles',
    PARAMS: 'params',
    CHARTS: 'charts',
    OWNER: 'owner',
    API_KEYS: 'api_keys',
    NOTIFS: 'notifs',
};
E.MONEY_DIRECTION = {
    IN: 'debit',
    OUT: 'credit',
};
E.IOS_REVIEW_EMAILS = [
    'sdk@brightdata.com',
    'sdk+1@brightdata.com',
    'sdk+2@brightdata.com',
    'sdkcompliance@brightdata.com',
];
E.CHECKLIST_QUESTION_KINDS = {
    TEXT: 'text',
    URL: 'url',
    BOOLEAN: 'bool',
};
E.CHECKLIST_HASH = 'checklist_hash';
E.CHECKLIST_TEXT_ANSWER_LEN = 200;
E.CHECKLIST_URL_ANSWER_LEN = E.MAX_URL_LEN;
E.ANALYSIS_STATUS = {
    NVM: 'nvm',
    PENDING: 'pending',
    MALICIOUS: 'malicious',
    MAYBE_OK: 'maybe_ok',
    OK: 'ok',
};
E.ANALYSIS_ENTITY = {
    FILE: 'file',
    URL: 'url',
};
E.PUBLIC_EMAIL = 'sdk@bright-sdk.com';
E.SECURITY_EMAIL = 'security@bright-sdk.com';
E.PARTNER_TIER = {
    AUTHORIZED: 'authorized',
    BRONZE: 'bronze',
    SILVER: 'silver',
    GOLD: 'gold',
    PLATINUM: 'platinum',
};
E.PARTNER_TIER_META = {
    [E.PARTNER_TIER.AUTHORIZED]: {
        name: 'Authorized',
        power: 0,
    },
    [E.PARTNER_TIER.BRONZE]: {
        name: 'Bronze',
        power: 10,
    },
    [E.PARTNER_TIER.SILVER]: {
        name: 'Silver',
        power: 20,
    },
    [E.PARTNER_TIER.GOLD]: {
        name: 'Gold',
        power: 30,
    },
    [E.PARTNER_TIER.PLATINUM]: {
        name: 'Platinum',
        power: 40,
    },
};
const MARKETING_REQUEST_FIELDS = [{
    id: 'activity',
    title: 'Suggested activity',
}, {
    id: 'creative_type',
    title: 'Creative type',
    hint: 'example: video ad, static ad, playable ad, animated GIF, etc',
}, {
    id: 'platform',
    title: 'Marketing Platform used for operation',
    hint: 'examples: Chartboost, Amazon ads, Vungle, AdColony, Google ads',
}, {
    id: 'geo_targeting',
    title: 'Geo targeting',
}, {
    id: 'budget',
    title: 'Requested budget',
}, {
    id: 'app',
    title: 'Which app will be promoted?',
}, {
    id: 'ongoing_campaigns',
    title: 'Are you currently running any campaigns?',
}, {
    id: 'comment',
    title: 'More details/comments:',
}];
const RND_REQUEST_FIELDS = [{
    id: 'os',
    title: 'Which OS will be developed',
}, {
    id: 'goals',
    title: 'How will the budget we invested?',
    hint: 'examples: developer, equipment, etc',
}, {
    id: 'budget',
    title: 'Requested budget',
}, {
    id: 'apps',
    title: 'Which apps will be developed?',
}, {
    id: 'comment',
    title: 'More details/comments:',
}];
E.FUNDS_REQUEST = {
    MARKETING: 'marketing',
    RND: 'rnd',
};
E.FUNDS_REQUEST_META = {
    [E.FUNDS_REQUEST.MARKETING]: {
        title: 'Funds Request: Marketing',
        short: 'Marketing',
        intro: 'Accelerate growth through targeted user'
            +' acquisition investments',
        fields: MARKETING_REQUEST_FIELDS,
        min_tier: E.PARTNER_TIER.BRONZE,
    },
    [E.FUNDS_REQUEST.RND]: {
        title: 'Funds Request: R&D',
        short: 'R&D',
        intro: 'Unleash innovation by fueling new app development'
            +' and expanding into new operating systems',
        fields: RND_REQUEST_FIELDS,
        min_tier: E.PARTNER_TIER.SILVER,
    },
};
E.FUNDS_REQUEST_TEXT_LIMIT = 1024;
E.BRIGHTDATA_PARTNER = 'brightdata';
E.SELF_CHECK_STAGE = {
    CLEANUP: 'cleanup',
    SEE_CONSENT: 'see_consent',
    ACCEPT_CONSENT: 'accept_consent',
    CANCEL_CONSENT: 'cancel_consent',
    OPT_IN_AGAIN: 'opt_in_again',
    BACKGROUND_ACTIVITY: 'background_activity',
    VERSION_CHECK: 'version_check',
};
E.SELF_CHECK_FLOW = [
    E.SELF_CHECK_STAGE.CLEANUP,
    E.SELF_CHECK_STAGE.SEE_CONSENT,
    E.SELF_CHECK_STAGE.ACCEPT_CONSENT,
    E.SELF_CHECK_STAGE.CANCEL_CONSENT,
    E.SELF_CHECK_STAGE.OPT_IN_AGAIN,
    E.SELF_CHECK_STAGE.BACKGROUND_ACTIVITY,
    E.SELF_CHECK_STAGE.VERSION_CHECK,
];
E.SELF_CHECK_STAGE_META = {
    [E.SELF_CHECK_STAGE.CLEANUP]: {},
    [E.SELF_CHECK_STAGE.SEE_CONSENT]: {},
    [E.SELF_CHECK_STAGE.ACCEPT_CONSENT]: {},
    [E.SELF_CHECK_STAGE.CANCEL_CONSENT]: {},
    [E.SELF_CHECK_STAGE.OPT_IN_AGAIN]: {},
    [E.SELF_CHECK_STAGE.BACKGROUND_ACTIVITY]: {
        os: ['win', 'android', 'webos', 'tizen'],
    },
    [E.SELF_CHECK_STAGE.VERSION_CHECK]: {},
};
E.SEARCH_RESULT_KIND = {
    APP: 'app',
    BUNDLE: 'bundle',
    USER: 'user',
    PARTNER: 'partner',
    PAGE: 'page',
};
E.NOTIF_EVENTS = {
    CREATED: 'created',
    EDITED: 'edited',
};
E.NOTIF_TARGET_KIND = {
    ALL: 'all',
    ROOTS: 'roots',
    OS: 'os',
    PARTNER: 'partner',
    USER: 'user',
    EMAIL: 'email',
};
E.NOTIF_NAME_MAX_LEN = 100;
E.NOTIF_BRIEF_MAX_LEN = 250;
E.NOTIF_BODY_MAX_LEN = 1500;
E.APP_URL_REQUIRED = {
    win: true,
};
E.APP_DAU_REQUIRED = {
    win: true,
};
E.APP_INSTALLS_REQUIRED = {
    win: true,
};
E.TTL = {
    SHORT: 'short',
    MEDIUM: 'medium',
};
E.TTL_META = {
    [E.TTL.SHORT]: 'Short',
    [E.TTL.MEDIUM]: 'Medium',
};
E.TRAY_ICON_MONITOR_NAME_MAX_LEN = 128;
E.TRAY_ICON_TEXT_MAX_LEN = 512;
E.TRAY_ICON_LINK_MAX_LEN = 256;
E.PAYMENT_TERMS_DUE = {
    NET7: 'net7',
    NET30: 'net30',
};
E.PAYMENT_TERMS_DUE_META = {
    [E.PAYMENT_TERMS_DUE.NET7]: {
        name: 'Net 7',
        delay: {day: 7},
    },
    [E.PAYMENT_TERMS_DUE.NET30]: {
        name: 'Net 30',
        delay: {day: 30},
    },
};
E.MAX_ADDRESS_ROW_LEN = 63;
E.MAX_ACCOUNT_ROW_LEN = 63;
E.PAYMENT_DETAILS_ADDRESS_ROWS = 5;
E.PAYMENT_DETAILS_ACCOUNT_ROWS = 15;
E.PAYMENT_METHOD = {
    WIRE: 'wire',
    PAYPAL: 'paypal',
    PAYONEER: 'payoneer',
};
E.PAYMENT_METHOD_META = {
    [E.PAYMENT_METHOD.WIRE]: 'Wire Transfer/ACH',
    [E.PAYMENT_METHOD.PAYPAL]: 'Paypal',
    [E.PAYMENT_METHOD.PAYONEER]: 'Payoneer',
};
E.PERMISSION = {
    ORG_ADMIN: 'org_admin',
    COMPANY: 'company',
    USERS: 'users',
    APPS: 'apps',
    STATS: 'stats',
    BILLING: 'billing',
    FILES: 'files',
    ROOT: 'root',
    ROOT_APPS_REVIEW: 'root:apps:review',
    ROOT_APPS_REVIEW_VERDICT: 'root:apps:review:verdict',
    ROOT_APPS_STATUS_CHANGE: 'root:apps:status_change',
    ROOT_BILLING_RATES: 'root:billing:rates',
    ROOT_BILLING_MANAGEMENT: 'root:billing:management',
    ROOT_BILLING_FORCE_PAID: 'root:billing:force_paid',
    ROOT_PARTNER_OTHER_PARAMS: 'root:partner:other_params',
    ROOT_STATS_COMMISSION: 'root:stats:commissions',
};
E.PERMISSIONS_LIST = Object.values(E.PERMISSION);
E.PERMISSION_LVL = {
    NONE: 0,
    N: 0,
    READ: 1,
    R: 1,
    WRITE: 2,
    W: 2,
};
E.PERMISSION_META = {
    [E.PERMISSION.ROOT]: {
        title: 'Root user',
        description: 'Bright SDK crew only. Full root access to'
            +' an every feature in SDK Dashboard',
        is_bool: true,
        is_super_root: true,
    },
    [E.PERMISSION.ORG_ADMIN]: {
        title: 'Company admin',
        description: 'Full access to an every feature in SDK Dashboard.'
            +' Can only be configured by Bright SDK crew',
        is_bool: true,
        is_root: true,
    },
    [E.PERMISSION.BILLING]: {
        title: 'Billing',
        description: 'Payment-related features, including billing setup'
            +' view and payments history',
    },
    [E.PERMISSION.STATS]: {
        title: 'Stats',
        description: 'Peers activity statistics and earnings',
    },
    [E.PERMISSION.APPS]: {
        title: 'Apps',
        description: 'Apps, checklists, review flow',
    },
    [E.PERMISSION.USERS]: {
        title: 'Users',
        description: 'Company users management',
    },
    [E.PERMISSION.COMPANY]: {
        title: 'Company',
        description: 'Company basic information management',
    },
    [E.PERMISSION.FILES]: {
        title: 'Files',
        description: 'Files upload and view',
    },
    [E.PERMISSION.ROOT_APPS_REVIEW]: {
        title: 'App review: start',
        description: 'Start a review, submit for a final decision',
        is_bool: true,
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_APPS_REVIEW_VERDICT]: {
        title: 'App review: verdict',
        description: 'Final step of review - approve or reject an app',
        is_bool: true,
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_APPS_STATUS_CHANGE]: {
        title: 'App profile: status editing',
        description: 'Editing of app statuses',
        is_bool: true,
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_BILLING_RATES]: {
        title: 'Billing: rates setup',
        description: 'Partner-, os-, and app-wide',
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_BILLING_MANAGEMENT]: {
        title: 'Billing: management',
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_BILLING_FORCE_PAID]: {
        title: 'Billing: force invoice status to paid',
        is_bool: true,
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_PARTNER_OTHER_PARAMS]: {
        title: 'Partner profile: other parameters',
        is_bool: true,
        is_super_root: true,
        root_permission: true,
    },
    [E.PERMISSION.ROOT_STATS_COMMISSION]: {
        title: 'Stats: commissions report',
        is_bool: true,
        is_super_root: true,
        root_permission: true,
    },
};
E.RATE_MAX_DIGITS = 6;
E.LIFETIME_ITEM = {
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year',
};
E.AUTH_TOKEN_LIFETIME = {
    [E.LIFETIME_ITEM.WEEK]: 1*ms.WEEK,
    [E.LIFETIME_ITEM.MONTH]: 1*ms.MONTH,
    [E.LIFETIME_ITEM.YEAR]: 1*ms.YEAR,
};
E.AUTH_TOKEN_NOTE_LEN = 32;
E.PARTNER_PARAMS_META = {
    no_pay: {
        type: 'bool',
        title: 'No pay',
        desciption: 'Calculate partner earnings but do not generate'
            +' transactions during monthly payouts',
    },
    restricted_access: {
        type: 'bool',
        true_bool: true,
        title: 'Restrict dashboard access',
        desciption: 'Limit a partner\'s access to the SDK dashboard.'
            +' It doesn\'t affect partner\'s active apps though',
    },
    optional_self_check: {
        type: 'bool',
        true_bool: true,
        title: 'Optional self-check',
        desciption: 'When switched on, partner will NOT be required to'
            +' pass self-check flow before submitting a new app for'
            +' a review',
    },
    'payment_terms.manual_payment': {
        type: 'bool',
        true_bool: true,
        title: 'Payment Terms: Manual and special payment terms',
        desciption: 'The partner has special payment terms and he is not'
            +' getting paid by peers records',
    },
    api_access: {
        type: 'bool',
        true_bool: true,
        title: 'API access',
    },
    tier: {
        type: 'enum',
        options: Object.values(E.PARTNER_TIER).map(value=>({
            value,
            label: E.PARTNER_TIER_META[value].name,
        })),
        title: 'Partner Program Level',
        desciption: 'Different program levels provide different benefits',
    },
    'payment_terms.due': {
        type: 'enum',
        options: Object.values(E.PAYMENT_TERMS_DUE).map(value=>({
            value,
            label: E.PAYMENT_TERMS_DUE_META[value].name,
        })),
        title: 'Payment Terms: Due Date',
        desciption: 'How many time we have to complete the monthly payment'
            +' after receiving an invoice from the partner',
    },
    'payment_terms.special': {
        type: 'markdown',
        title: 'Payment Terms: Special conditions',
        max_len: E.MAX_APP_COMMENT_LEN,
    },
    notes: {
        type: 'markdown',
        title: 'Notes',
        max_len: E.MAX_APP_COMMENT_LEN,
    },
};
E.AUTH_ROUTES = {
    AUTH_SIGNIN: '/auth/signin',
    AUTH_SIGNUP: '/auth/signup',
    AUTH_RESET: '/auth/reset',
    AUTH_EMAIL_VERIFY: '/unverified_email',
    ONBOARDING: '/onboarding',
};
E.OAUTH_PROVIDER = {
    GOOGLE: 'google',
    GITHUB: 'github',
    OKTA: 'okta',
};
E.SIGNUP_PROVIDER_META = {
    basic: {title: 'Email and password'},
    [E.OAUTH_PROVIDER.GOOGLE]: {title: 'Google OAuth'},
    [E.OAUTH_PROVIDER.GITHUB]: {title: 'Github OAuth'},
    [E.OAUTH_PROVIDER.OKTA]: {title: 'okta OAuth'},
};
E.ENABLED_OAUTH_PROVIDERS = [
    E.OAUTH_PROVIDER.GOOGLE,
    E.OAUTH_PROVIDER.GITHUB,
    E.OAUTH_PROVIDER.OKTA,
];
E.ALL_PARTNERS_UUID = 'all';
E.COMMISSION_CHUNK_LEN = 30;
E.COMMISSION_PERIOD_LEN = 150;
E.COMMISSION_ERROR = {
    START_YMD_MISSING: 'no_start_ymd',
    START_YMD_STALE: 'too_old_start_ymd',
};
E.COMMISSION_ERROR_META = {
    [E.COMMISSION_ERROR.START_YMD_MISSING]: {
        title: 'Report start date is missing',
        configure_link: true,
    },
    [E.COMMISSION_ERROR.START_YMD_STALE]: {
        title: 'Report start date is too old',
        configure_link: true,
    },
    default: {
        title: 'Something went wrong. Please try again later.',
    },
};
E.APP_PARAMS_META = {
    qualified_min: {
        type: 'number',
        placeholder: 'Amount',
        min: 0,
        title: 'Qualified minutes',
        desciption: 'A daily minimum minutes amount which an app\'s peer has'
            +' to be online to be counted during a billing',
    },
    certified: {
        type: 'bool',
        title: 'AppEsteem certified',
        desciption: 'The app is certified by an organisation AppEsteem',
    },
    no_check: {
        type: 'bool',
        title: 'No check',
        desciption: 'Skip the app in monthly sanity procedures',
    },
    external_consent: {
        type: 'bool',
        title: 'External consent enabled',
        desciption: '',
    },
    managed_https: {
        type: 'bool',
        title: 'Managed HTTPS',
        desciption: '',
        os: ['ios'],
    },
    distribution_stopped: {
        type: 'bool',
        title: 'Discontinued',
        desciption: 'App is no longer distributed by the partner'
            +' but still has active peers',
    },
    ttl: {
        type: 'enum',
        options: Object.values(E.TTL).map(value=>({
            value,
            label: E.TTL_META[value],
        })),
        title: 'Time to live (TTL)',
        desciption: 'Expected peer lifetime. Peers with lower values will'
            +' have higher priority to be used.',
        os: ['ios', 'roku'],
    },
    allowed_countries: {
        type: 'country_list',
        title: 'Allowed Countries',
        desciption: '',
    },
    blacklist_countries: {
        type: 'country_list',
        title: 'Blacklist Countries',
        desciption: '',
    },
    'commissions.us_rate': {
        type: 'number',
        placeholder: '0.03',
        min: 0,
        title: 'Commissions report: US rate',
    },
    'commissions.row_rate': {
        type: 'number',
        placeholder: '0.003',
        min: 0,
        title: 'Commissions report: ROW rate',
    },
    'commissions.start_ymd': {
        type: 'date',
        placeholder: '2020-01-01',
        title: 'Commissions report: Start date',
    },
    notes: {
        type: 'markdown',
        title: 'Notes',
        max_len: E.MAX_APP_COMMENT_LEN,
    },
};
E.REVIEW_PRIORITY = {
    NORMAL: 'normal',
    HIGH: 'high',
};
E.CONTEST = {
    SEP_2024: 'sep_2024',
};
E.BNDL_OFFER_KIND = {
    WIZARD: 'wizard',
    UNINSTALL: 'uninstall',
    BANNER: 'banner',
    INSTALL: 'install',
    G_AD: 'g_ad',
    PREINSTALLED: 'pre_install',
};
E.BNDL_OFFER_META = {
    [E.BNDL_OFFER_KIND.WIZARD]: {
        name: 'Installation Wizard Offer',
    },
    [E.BNDL_OFFER_KIND.BANNER]: {
        name: 'In-App Offer',
    },
    [E.BNDL_OFFER_KIND.INSTALL]: {
        name: 'Successful Installation offer',
    },
    [E.BNDL_OFFER_KIND.UNINSTALL]: {
        name: 'Uninstall Page Offer',
    },
    [E.BNDL_OFFER_KIND.G_AD]: {
        name: 'Ad Campaign',
    },
    [E.BNDL_OFFER_KIND.PREINSTALLED]: {
        name: 'Preinstalled app',
    },
};
E.BRD_PRODUCT_KIND = {
    VPN: 'brightvpn',
};
E.BUNDLES_META = {
    [E.BRD_PRODUCT_KIND.VPN]: {
        win: {
            offer_kinds: [
                E.BNDL_OFFER_KIND.BANNER,
                E.BNDL_OFFER_KIND.INSTALL,
                E.BNDL_OFFER_KIND.UNINSTALL,
                E.BNDL_OFFER_KIND.WIZARD,
                E.BNDL_OFFER_KIND.G_AD,
                E.BNDL_OFFER_KIND.PREINSTALLED,
            ],
        },
    },
};
E.BUNDLE_SUFFIX = '__bundle';
E.COMPLIANCE_SUFFIX = '__compliance';
E.PARTNER_ENTITY_KIND = {
    INDIVIDUAL: 'individual',
    COMPANY: 'company',
};
E.PARTNER_ENTITY_META = {
    [E.PARTNER_ENTITY_KIND.INDIVIDUAL]: {
        value: E.PARTNER_ENTITY_KIND.INDIVIDUAL,
        label: 'Individual',
        ico: 'ico_user',
    },
    [E.PARTNER_ENTITY_KIND.COMPANY]: {
        value: E.PARTNER_ENTITY_KIND.COMPANY,
        label: 'Company',
        ico: 'ico_group',
    },
};
E.MAX_LEGAL_NAME_LEN = 128;
E.MAX_GOV_ID_LEN = 128;
E.MAX_LEGAL_ADDR_LEN = 512;
